import { useTheme } from '@mui/material/styles';
import { StatusChip } from './StatusChip';


const statusPalette = (theme, status) => {
    let result
    switch (status?.toLowerCase()) {
        case 'desktop':
        case 'desktop qa':
            result = theme.palette.statusActive // blue
            break;
        case 'field':
        case 'field qa':
            result = theme.palette.statusComplete // green
            break
        case 'remedial':
            result = theme.palette.statusPaused // orange
            break
        case 'fsp':
                result = theme.palette.info // blue
                break
        case 'eliminated':
            result = theme.palette.statusPending // gray
            break
        default:
            result = theme.palette.statusIdle
    }
    return result
}

export default function DlspTaskStatusChip({status, statusReason, ...props}) {
    const theme = useTheme();
    const chipPalette = statusPalette(theme, status)
    return (
        <StatusChip
            status={status}
            statusReason={statusReason}
            chipPalette={chipPalette}
            {...props} />
 
    )
}

